import { render, staticRenderFns } from "./EditTag.vue?vue&type=template&id=2242ed21&"
import script from "./EditTag.vue?vue&type=script&lang=ts&"
export * from "./EditTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports